import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/reprocesar`;


export async function reprocesarParticipante(participanteId, observacion = "") {
  const res = await axios.post(baseUrl, {
    participanteId,
    observacion
  });

  return res.data;
}